"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupWebpackPublicPath = void 0;
var browser_1 = require("@cian/config/browser");
function setupWebpackPublicPath() {
    var config = (0, browser_1.getConfig)();
    var publicPath = config.getStrict('web.manifest.assetsBaseUrl');
    // eslint-disable-next-line
    __webpack_public_path__ = publicPath;
}
exports.setupWebpackPublicPath = setupWebpackPublicPath;
//# sourceMappingURL=setup.js.map